import { PharmacyHours } from "./PharmacyHours.js";
import { Address, Box, Distance, Flex, PhoneNumber, Stack } from "@myphx-engineering/phx-design-system";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

//#region src/components/pharmacy-info/PharmacyInfoCompact.tsx
const PharmacyInfoCompact = ({ address, distance, phone, hours, locale = "en-US" }) => {
	const locationDetails = [];
	if (distance) locationDetails.push(/* @__PURE__ */ jsx(Distance, {
		showIcon: false,
		...distance,
		locale
	}));
	if (address) locationDetails.push(/* @__PURE__ */ jsx(Address, {
		showIcon: false,
		address
	}));
	return /* @__PURE__ */ jsxs(Stack, {
		gap: "xxs",
		children: [
			locationDetails.length ? /* @__PURE__ */ jsx(Flex, {
				gap: "xxxs",
				align: "center",
				children: locationDetails.map((line, idx) => /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Box, { children: line }, idx), idx !== locationDetails.length - 1 && " • "] }))
			}) : null,
			hours ? /* @__PURE__ */ jsx(PharmacyHours, {
				showIcon: false,
				hours
			}) : void 0,
			phone ? /* @__PURE__ */ jsx(PhoneNumber, {
				showIcon: false,
				phone
			}) : void 0
		]
	});
};

//#endregion
export { PharmacyInfoCompact };